import {DriverDiscoverySourceEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function discoverySourceNameFilter(type: DriverDiscoverySourceEnum): string {
  switch (type) {
    case DriverDiscoverySourceEnum.Facebook: return 'Facebook';
    case DriverDiscoverySourceEnum.Olx: return 'Olx';
    case DriverDiscoverySourceEnum.GoogleMaps: return 'Google Maps';
    case DriverDiscoverySourceEnum.Posters: return i18n.t(LF.Posters) as string;
    case DriverDiscoverySourceEnum.Instagram: return 'Instagram';
    case DriverDiscoverySourceEnum.LargeScreenAdvertising: return i18n.t(LF.LargeScreenAdvertising) as string;
    case DriverDiscoverySourceEnum.CarAdvertising: return i18n.t(LF.CarAdvertising) as string;
    case DriverDiscoverySourceEnum.FriendReferral: return i18n.t(LF.FriendReferral) as string;
    case DriverDiscoverySourceEnum.GoogleSearch: return i18n.t(LF.GoogleSearch) as string;
    case DriverDiscoverySourceEnum.BlueCityAdvertising: return i18n.t(LF.BlueCityAdvertising) as string;
    case DriverDiscoverySourceEnum.BikeAdvertising: return i18n.t(LF.BikeAdvertising) as string;
    case DriverDiscoverySourceEnum.OtherAdvertising: return i18n.t(LF.OtherAdvertising) as string;
    default: return i18n.t(LF.Undefined) as string;
  }
}
